// extracted by mini-css-extract-plugin
module.exports = {"root":"SanityRichTextField_root__1eInI","multiline":"SanityRichTextField_multiline__4IIfr"};